import { render, staticRenderFns } from "./ModelInfoCard.vue?vue&type=template&id=625d7482&scoped=true"
import script from "./ModelInfoCard.vue?vue&type=script&lang=js"
export * from "./ModelInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ModelInfoCard.vue?vue&type=style&index=0&id=625d7482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d7482",
  null
  
)

export default component.exports